<template>
    <div ref="customcard" class="card">
        <div class="card-header" v-if="hasHeader">
            <div
                class="card-header-title"
                :class="[!!this.$slots['action'] ? 'w-1/2' : '']"
            >
                <span class="card-header-title--text">{{ title }}</span
                ><i
                    title="Click to see the functionality of the action buttons"
                    class="info-popup"
                    v-if="tooltips && alias in tooltips"
                    @click="showModalDetailLog = true"
                    >i</i
                >
            </div>
            <div v-if="this.$slots['action']" class="card-action--container">
                <slot name="action"></slot>
            </div>
        </div>
        <div
            class="card-content flex w-full"
            :class="contentClass"
            :style="contentStyle"
        >
            <slot></slot>
        </div>
        <popup-custom
            v-if="tooltips && alias in tooltips"
            show-variable="showModalDetailLog"
            title=""
            content-width="750"
            content-height="70%"
            style-height="autoHeightBlock"
        >
            <template v-slot:content>
                <template v-if="!canEdit">
                    <div class="w-full textareashow" v-if="!tooltips[alias]">
                        <i>Please click on edit to update the action note.</i>
                    </div>
                    <div
                        class="w-full textareashow"
                        v-else
                        v-html="tooltips[alias]"
                    />
                </template>
                <div class="w-full" v-if="canEdit">
                    <textarea
                        ref="textareaedit"
                        class="textareaedit w-full p-2 overflow-y-auto"
                        @keydown="startKeyUp"
                        :value="tooltips[alias]"
                    ></textarea>
                </div>
            </template>
            <template v-slot:footer>
                <div class="w-full flex justify-end">
                    <button
                        v-if="['admin'].includes(authenticatedUser.role)"
                        @click="changeTooltip(alias)"
                        class="btn btn-primary mr-1"
                    >
                        <span class="btn--text custom-text-bold">{{
                            startEdit ? "Save" : "Edit"
                        }}</span>
                    </button>
                    <button
                        @click="showModalDetailLog = false"
                        class="btn btn-primary"
                    >
                        <span class="btn--text custom-text-bold">Close</span>
                    </button>
                </div>
            </template>
        </popup-custom>
    </div>
</template>

<script>
import { mapGetters, useStore } from "vuex";
import { computed, getCurrentInstance } from "vue";
export default {
    name: "CardCustom",
    props: {
        title: String,
        subtitle: String,
        display: {
            default: "flex",
            type: String,
        },
        contentClass: {
            default: "",
            type: String,
        },
        contentStyle: {
            default: "",
            type: String,
        },
        alias: {
            default: "",
            type: String,
        },
    },
    data() {
        return {
            showModalDetailLog: false,
            canEdit: false,
            startEdit: false,
        };
    },
    computed: {
        ...mapGetters(["tooltips"]),
        hasHeader() {
            return this.title || this.subtitle;
        },
    },
    methods: {
        changeTooltip(alias) {
            if (this.startEdit) {
                let message = this.$refs.textareaedit.value;
                this.$store.dispatch("updateToolip", { alias, message });
                this.canEdit = false;
                this.startEdit = false;
            } else {
                this.canEdit = true;
            }
        },
        startKeyUp() {
            if (!this.startEdit) {
                this.startEdit = true;
            }
        },
    },

    setup() {
        const store = useStore();
        const instance = getCurrentInstance();
        const authenticatedUser = computed(() => {
            return instance.appContext.config.globalProperties.$globalVariables.authenticatedUser(
                store
            );
        });

        return {
            authenticatedUser,
        };
    },
};
</script>

<style scoped>
.info-popup {
    color: var(--color-default);
    background: #ffffff;
    width: 17px;
    height: 17px;
    font-style: normal;
    line-height: 18px;
    text-align: center;
    display: inline-block;
    border-radius: 20px;
    margin-left: 5px;
    cursor: pointer;
    border: 1px solid var(--color-default);
    font-weight: bold;
}
.info-popup:hover {
    background: var(--color-base-darker);
}
.autoHeightBlock {
    height: auto !important;
    max-height: 100vh !important;
}
.textareashow {
    white-space: pre;
}
.textareaedit {
    min-height: 300px;
}
</style>
